import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'
import { AnyObject, Field, Form } from 'react-final-form'
import { FontAwesomeSvgIcon as FontAwesomeIcon } from 'react-fontawesome-svg-icon'

import { faArrowRight } from '@fortawesome/pro-light-svg-icons/faArrowRight'
import { faSpinnerThird } from '@fortawesome/pro-light-svg-icons/faSpinnerThird'

import Notification from '@infura/packages.components/Notification'

import { CaptchaModal } from 'components/CaptchaModal'
import FooterLinksForm from 'components/wallet/FooterLinksForm'

import { SubmissionErrors } from 'final-form'
import { AUTH_WALLET_PAIRING } from 'lib/siwsrp/auth'
import { Infura } from 'lib/types/infuraTypes'

type Props = {
  onSubmit: (props: {
    authLoginMethod: Infura.AUTH_LOGIN_METHOD.WALLET
    recaptcha: string
    user: { email: string }
  }) => Promise<boolean | AnyObject | SubmissionErrors>
}

export default function UsersWalletPairing({ onSubmit }: Props) {
  const { asPath } = useRouter()
  const usersWalletPairing = JSON.parse(localStorage.getItem(AUTH_WALLET_PAIRING)!)
  const [captchaModalOpen, setCaptchaModalOpen] = useState(false)

  useEffect(() => {
    const initPageView = async () => {
      window.analytics.page(asPath, {
        page_name: 'Metamask Login - Multi accounts pairing',
        user_experience: 'B'
      })
    }
    if (window?.analytics) initPageView()
  }, [asPath])

  return (
    <>
      <h1 className='font-body xxl:text-4xl mb-4 text-3xl font-bold'>Choose an Account</h1>
      <p className='text-lg font-medium'>Select the account you wish to use.</p>

      <Form
        initialValues={{ authLoginMethod: Infura.AUTH_LOGIN_METHOD.WALLET }}
        onSubmit={onSubmit}
        render={({ handleSubmit, submitError, submitting }) => {
          return (
            <form className='xxl:text-lg text-base' data-testid='auth-wallet-pairing-form' onSubmit={handleSubmit}>
              {submitError ? (
                <Notification className='mb-6' color='alert' data-testid='auth-form-error' size='sm' variant='outlined'>
                  <span className='w-full text-center'>{submitError}</span>
                </Notification>
              ) : null}
              {submitting ? (
                <FontAwesomeIcon className='fa-fw fa-spin text-text-defauult ' icon={faSpinnerThird} />
              ) : (
                <Field name='user'>
                  {({ input }) =>
                    usersWalletPairing?.map(user => (
                      <div className='min-w-105 border-border-default border-b py-4 text-left' key={user.userId}>
                        <button
                          className='w-full cursor-pointer text-left'
                          onClick={() => {
                            input.onChange(user)
                            setCaptchaModalOpen(true)
                          }}
                          type='button'
                        >
                          <p className='text-primary-default m-0 flex items-center gap-2 font-medium'>
                            <span className='hover:underline'>{user.email}</span>
                            <FontAwesomeIcon className='text-primary-default ml-1' icon={faArrowRight} />
                          </p>
                        </button>
                      </div>
                    ))
                  }
                </Field>
              )}
              <CaptchaModal open={captchaModalOpen} setIsOpen={setCaptchaModalOpen} />
            </form>
          )
        }}
      />
      <FooterLinksForm />
    </>
  )
}
